import { UserPreferences, UserProfile } from "../../../interfaces/UserObject";

function buildUpdateProfilePayload(profileDb: UserProfile): any {
  const userName = profileDb.userName;
  const personalEmail = profileDb.personalEmail || "";
  const phone = profileDb.phone;
  const aboutMe = profileDb.aboutMe;
  const userPreferences = profileDb.userPreferences || "{}";
  const corporateEmail = profileDb.corporateEmail;
  const address = profileDb.address;

  return {
    profile: {
      userName: userName,
      personalEmail: personalEmail,
      corporateEmail: corporateEmail,
      phone: phone,
      aboutMe: aboutMe,
      userPreferences: userPreferences,
      address: address,
    },
  };
}

function buildUpdateUserPreferencesPayload(userPreferences: UserPreferences): any {

  const searchRadius = userPreferences.searchRadius || null;
  const ninefindsRadius = userPreferences.ninefindsRadius || null;
  const defaultRadius = userPreferences.defaultRadius || null;
  const latitude = userPreferences.userLocation?.userLatitude || null;
  const longitude = userPreferences.userLocation?.userLongitude || null;
  const userLocationDisplayName = userPreferences.userLocation?.userLocationDisplayName || null;
  const isHyperLocalEnabled = userPreferences.isHyperLocalEnabled || false;
  const hyperLocalDistance = userPreferences.hyperLocalDistance || null;
  const searchSortBy = userPreferences.searchSortBy || null;
  const preferenceId = userPreferences.preferenceId || null;

  return {
    preferenceId: preferenceId,
    searchRadius: searchRadius,
    ninefindsRadius: ninefindsRadius,
    defaultRadius: defaultRadius,
    userLatitude: latitude,
    userLongitude: longitude,
    userLocation: userLocationDisplayName,
    isHyperLocalEnabled: isHyperLocalEnabled,
    hyperLocalDistance: hyperLocalDistance,
    searchSortBy: searchSortBy,
  };
}

const UserConvertorService = {
  buildUpdateProfilePayload,
  buildUpdateUserPreferencesPayload,
};

export default UserConvertorService;
